

// add assets to public/assets and list their urls here under `/assets`
// (the public folder gets turned into the site's base directory)


/**
 * "Mid frequency speaker" (https://skfb.ly/o6IFB) by pajermark is licensed
 * under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
 */
// i think this .obj is referencing a .mtl file that didn't come zipped with it
// so no colors show up ¯\_(ツ)_/¯
export const speaker = '/assets/speaker.obj'

export const scenes = []

export const audioFiles = {
  melody: '/assets/melody.mp3',
  // song by Noam Bendelac
  song: {
    track_1_Kick:    '/assets/song/ss21_4_tracks_1_Kick.mp3',
    track_2_Snare:   '/assets/song/ss21_4_tracks_2_Snare.mp3',
    track_3_Clap:    '/assets/song/ss21_4_tracks_3_Clap.mp3',
    track_4_Perc:    '/assets/song/ss21_4_tracks_4_Perc.mp3',
    track_5_Hat:     '/assets/song/ss21_4_tracks_5_Hat.mp3',
    track_6_Cymbal:  '/assets/song/ss21_4_tracks_6_Cymbal.mp3',
    track_9_Bass:    '/assets/song/ss21_4_tracks_9_Bass.mp3',
    track_10_Pad1:   '/assets/song/ss21_4_tracks_10_Pad1.mp3',
    track_11_Sub:    '/assets/song/ss21_4_tracks_11_Sub.mp3',
    track_12_Noise:  '/assets/song/ss21_4_tracks_12_Noise.mp3',
    track_13_Chimes: '/assets/song/ss21_4_tracks_13_Chimes.mp3',
    track_14_Pad2:   '/assets/song/ss21_4_tracks_14_Pad2.mp3',
    track_15_Pad3:   '/assets/song/ss21_4_tracks_15_Pad3.mp3',
  }
}

